import React, { useEffect, useState } from 'react'
import { Panel } from 'rsuite'
import 'rsuite/dist/rsuite.min.css'
import { PanelHeader } from '../panels'
import { PresidentIcon } from '../icons'
import { useParams } from 'react-router-dom'
import { useEnvironment } from '../../hooks/useEnvironment'
import { useRequestsEvents } from '../../hooks/useRequestsEvents'
import { EmptyResult, ErrorResult, LoaderBackDrop } from '../feedbacks'
import _ from 'lodash'
import { PromotionPersonTable } from './tables/PromotionPersonTable'

export const PromotionPersonPresidentPanel = (props) => {
  // get current promotion id
  const { promotionId } = useParams()
  // for get promotions
  const { getPromotionPresident } = useRequestsEvents()
  // get permissions
  const { hasPromotionPermissions } = useEnvironment()
  // component config
  const [componentCfg, setComponentCfg] = useState({
    data: {},
    isLoaded: false,
    isError: false,
    isForbidden: false
  }) // permissions
  const hasReadPresidentPromotionPermission = hasPromotionPermissions(promotionId, 'read:promotion:president') && !componentCfg.isForbidden
  const hasUpdatePresidentPromotionPermission = hasPromotionPermissions(promotionId, 'update:promotion:president') && !componentCfg.isForbidden
  const hasDeletePresidentPromotionPermission = hasPromotionPermissions(promotionId, 'delete:promotion:president') && !componentCfg.isForbidden

  // for load all promotions data when component is mounted
  useEffect(() => {
    // clean up controller --> prevent crash with async function
    let isMounted = true
    // not reload if component is loaded...
    if (componentCfg.isLoaded) { return }
    // if not has permissions
    if (!hasReadPresidentPromotionPermission) {
      setComponentCfg({ ...componentCfg, isError: false, isLoaded: true, data: {} })
    } else {
      // get promotion holder data
      getPromotionPresident(promotionId, (result) => {
        // prevent async crash
        if (!isMounted) return null
        // get holder data
        const data = result.data
        // set holder data
        setComponentCfg({ ...componentCfg, isError: false, isLoaded: true, data, isForbidden: false })
      }, (err) => {
        // prevent async crash
        if (!isMounted) return null
        if (err === 403) {
          setComponentCfg({ ...componentCfg, isError: false, isLoaded: true, data: {}, isForbidden: true })
        } else {
          setComponentCfg({ ...componentCfg, isError: true, isLoaded: true, data: {}, isForbidden: false })
        }
      })
    }// prevent crash with async function
    return () => { isMounted = false }
  }, [componentCfg.isLoaded])

  return (<>
    {(() => { /* check permissions */
      if (!hasReadPresidentPromotionPermission || _.isEmpty(componentCfg.data)) {
        return <></>
      } else { /* render a panel */
        return (
          <Panel bodyFill header={
            <PanelHeader icon={<PresidentIcon />} title={'dashboard.promotion.president'} hasEdit={hasUpdatePresidentPromotionPermission} hasDelete={hasDeletePresidentPromotionPermission} />
          }>
            <LoaderBackDrop active={!componentCfg.isLoaded} loader background bordered>
              <Panel className={'filled-table-panel'} style={{ borderRadius: '4px' }} bordered bodyFill>
                  { /* load component */ }
                  {(() => {
                    if (componentCfg.isError) {
                      return <ErrorResult compact={true}/>
                    } else if (_.isEmpty(componentCfg.data)) {
                      return <EmptyResult compact={true} />
                    } else { /* return components to render */
                      return <PromotionPersonTable data={componentCfg.data}/>
                    }
                  })()}
              </Panel>
            </LoaderBackDrop>
          </Panel>
        )
      }
    })()}
  </>)
}
